import axios from "axios"
import API_URLS from "../../config/global_variables";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";

const get_category_tree = async (store_id) => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_CATAGORY_TREE,
      headers: {
        'Content-Type': 'application/json','Authorization': userData.token
      },
      data: JSON.stringify({store_id:store_id})
    };

    let data = await axios.request(config)

    if (data.status === 200) {
      return data.data.data
    }
    return [];

  } catch (error) {
    return [];
  }

}
const update_product = async (req_data) => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_BC_PRODUCT,
      headers: {
        'Content-Type': 'application/json','Authorization': userData.token
      },
      data: JSON.stringify(req_data)
    };

    let data = await axios.request(config)

    if (data.status === 200) {
      return data
    }
    return [];

  } catch (error) {
    return [];
  }

}
const apiService = {get_category_tree, update_product};

export default apiService;
